import { DialogDesignTokens } from '@primeuix/themes/types/dialog';

import {
  getColor,
  getFontWeight,
  getRem,
} from '@customer-portal/shared/helpers/theme-utils';

export const dialogOverride: DialogDesignTokens = {
  root: {
    color: getColor('DarkBlue'),
    borderRadius: getRem(10),
  },
  header: {
    padding: `${getRem(24)} ${getRem(32)}`,
  },
  title: {
    fontSize: getRem(28),
    fontWeight: getFontWeight('bold'),
  },
  footer: {
    padding: `${getRem(24)} ${getRem(32)}`,
  },
  content: {
    padding: `${getRem(24)} ${getRem(32)}`,
  },
};
